import request from '@/utils/http'
const AUTH_BASE_URL = "/api/v1";
export const getOrderAPI = (id) => {
    return request({
        url: `/member/order/${id}`
    })
}
/**
 * 
 * @param  发布商品
 * @returns 
 */
export const setshelvesFilterAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/upload/generatePreUploadUrl`,
        method: 'POST',
        data
    })
}